module.exports = __webpack_public_path__ + "static/media/carPhoto.5463c39f.jpg";